// Exports
export default {
	"Menu": "Menu_X97+g",
	"MenuButton": "MenuButton_1zyp0",
	"IconContainer": "IconContainer_Bb9Ai",
	"Icon": "Icon_Sr7-e",
	"Container": "Container_IsgLG"
};
